export default __webpack_public_path__ + "static/media/quizbutton.bd3e4407.png";